<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    required: true,
  },
  valueKey: {
    type: String,
    default: "value",
  },
  keyField: {
    type: String,
    default: "id",
  },
  disabledKey: {
    type: String,
    default: "disabled",
  },
  redeemedKey: {
    type: String,
    default: "redeemed",
  },
})

const emit = defineEmits(["update:modelValue"])

function getOptionValue(option) {
  return option?.[props.valueKey]
}

function getOptionKey(option) {
  return option?.[props.keyField] ?? getOptionValue(option)
}

function isChecked(option) {
  const value = getOptionValue(option)
  return (props.modelValue || []).includes(value)
}

function isDisabled(option) {
  return Boolean(option?.[props.disabledKey]) && !isRedeemed(option)
}

function isRedeemed(option) {
  return Boolean(option?.[props.redeemedKey])
}

function toggle(option) {
  if (isDisabled(option)) return
  const value = getOptionValue(option)
  const current = props.modelValue || []
  const next = current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value]
  emit("update:modelValue", next)
}
</script>
